<div class="content-container lca-view-mode" *ngIf="lcaDetails">
    <div class="row" class="page-heading">
        <h5 class="labelText mb-2">Update Decision</h5>
    </div>
    <div class="row">
        <button class="back-button back-btn-white-bg pl-0" (click)="backToOriginPage()"><i
                class="fa fa-chevron-circle-left" aria-hidden="true"></i>
            Back
        </button>
    </div>

    <div class="table-container row p-0 mat-elevation-z8">
        <table mat-table [dataSource]="dataSource" class="col-md-12 mb-4">

            <!-- Case No Column -->
            <ng-container matColumnDef="caseNumber">
                <th mat-header-cell *matHeaderCellDef> Case No </th>
                <td mat-cell *matCellDef="let element"> {{element.caseNumber || 'N/A'}} </td>
            </ng-container>

            <!-- SOC Job Title Column -->
            <ng-container matColumnDef="socTitle">
                <th mat-header-cell *matHeaderCellDef> SOC Job Title </th>
                <td mat-cell *matCellDef="let element"> {{element.socTitle || 'N/A'}} </td>
            </ng-container>

            <!-- SOC Code Column -->
            <ng-container matColumnDef="socCode">
                <th mat-header-cell *matHeaderCellDef> SOC Code </th>
                <td mat-cell *matCellDef="let element"> {{element.socCode || 'N/A'}} </td>
            </ng-container>

            <!-- Employment Start Date Column -->
            <ng-container matColumnDef="employmentStartDate">
                <th mat-header-cell *matHeaderCellDef> Employment Start Date </th>
                <td mat-cell *matCellDef="let element"> {{element.employmentStartDate || 'N/A'}} </td>
            </ng-container>

            <!-- Employment End Date Column -->
            <ng-container matColumnDef="employmentEndDate">
                <th mat-header-cell *matHeaderCellDef> Employment End Date </th>
                <td mat-cell *matCellDef="let element"> {{element.employmentEndDate || 'N/A'}} </td>
            </ng-container>

            <!-- Company Name Column -->
            <ng-container matColumnDef="companyName">
                <th mat-header-cell *matHeaderCellDef> Company Name </th>
                <td mat-cell *matCellDef="let element"> {{element.company?.companyName || 'N/A'}} </td>
            </ng-container>

            <!-- Visa Type Column -->
            <ng-container matColumnDef="visaType">
                <th mat-header-cell *matHeaderCellDef> Visa Type </th>
                <td mat-cell *matCellDef="let element"> {{element.visaType?.name || 'N/A'}} </td>
            </ng-container>

            <!-- Notes Column -->
            <ng-container matColumnDef="notes">
                <th mat-header-cell *matHeaderCellDef> Notes </th>
                <td mat-cell *matCellDef="let element"> {{element.comment || 'N/A'}} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td mat-cell *matCellDef="let element"> {{element.status?.name || 'N/A'}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="update-decision-form col-md-12 mt-4">
            <form [formGroup]="lcaForm">
                <!-- Decision Radio Buttons -->
                <div class="col-3 mt-1 pl-3 mb-4">
                    <h6 class="labelText"><b> What is the Decision?</b></h6>
                    <div class="row pt-2">
                        <mat-radio-group formControlName="decision" aria-label="Select an option" >
                            <mat-radio-button value="Certified">Certified</mat-radio-button>
                            <mat-radio-button value="Not Certified">Not Certified</mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>

                <!-- LCA Certification Details (Conditional based on decision) -->
                <div *ngIf="lcaForm.get('decision').value === 'Certified'">
                    <h6 class="labelText"><b> Enter the Certified LCA Details</b></h6>
                    <div class="row">
                        <div class="col-3">
                            <label class="control-lbl mt-2 label-cls d-block required">LCA Certification Date</label>
                            <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                                <input formControlName="certificationDate" name="lcaAppliedDateRef" matInput
                                    [matDatepicker]="lcaAppliedDate" (click)="lcaAppliedDate.open()" 
                                    placeholder="MM/DD/YYYY">
                                <mat-datepicker-toggle matSuffix [for]="lcaAppliedDate"></mat-datepicker-toggle>
                                <mat-datepicker #lcaAppliedDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-9">
                            <label class="control-lbl mt-2 label-cls d-block">Upload Certified LCA</label>
                            <app-file-upload style="width: 100%;"
                                [configurations]="cerifiedLcaConfigurations"></app-file-upload>
                        </div>
                    </div>
                </div>

                <div>
                    <div class="col-md-12">
                        <div class="form-group">
                            <label class="label-cls required">Notes</label>
                            <textarea class="im-input" name="statusChangeReason" rows="3" cols="50"
                                formControlName="notes" placeholder="Enter">
                            </textarea>
                        </div>
                    </div>
                </div>

                <mat-divider></mat-divider>

                <div>
                    <div class="pt-3 pl-3">
                        <h6 class="labelText"><b> Workforce Notification Details</b></h6>
                    </div>
                    <div class="pt-2">
                        <div class="row">
                            <div class="col-md-4 mt-1">
                                <span>Did you notify the Workforce</span>
                                <p-inputSwitch formControlName="workforceNotified" styleClass="lcaWorkNotifySwitch"
                                    class="ml-4"></p-inputSwitch>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3" *ngIf="lcaForm.get('workforceNotified').value">
                                <label class="control-lbl mt-2 label-cls d-block required">Workforce Notification
                                    Date</label>
                                <mat-form-field class="matformfieldwidth1 w-100 date-field" appearance="outline">
                                    <input formControlName="workforceNotifiedDate" name="workforceNotifiedDateRef"
                                        matInput [matDatepicker]="workforceNotifiedDate"
                                        (click)="workforceNotifiedDate.open()">
                                    <mat-datepicker-toggle matSuffix
                                        [for]="workforceNotifiedDate"></mat-datepicker-toggle>
                                    <mat-datepicker #workforceNotifiedDate></mat-datepicker>
                                </mat-form-field>
                            </div>

                            <div class="col-md-9 pl-2 pt-3" *ngIf="lcaForm.get('workforceNotified').value">
                                <div>
                                    <label for="tasktype">Upload proof of the 'Workforce
                                        Notification'</label>
                                    <app-file-upload style="width: 100%;" [configurations]="workForceConfigurations"
                                        (fileUploadSuccess)="getWorkForceUpolodedFiles()"></app-file-upload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!lcaForm.get('workforceNotified').value">
                        <div class="p-fluid p-formgrid p-grid pt-3 pl-3">
                            <div class="p-col-8">
                                <p>Download template samples on how to Notify workspace</p>
                            </div>
                        </div>
                        <div class="row ml-2">
                            <div *ngIf="lcaDetails.lcaApplication && lcaDetails.lcaApplication.sampleFileOne"
                                class="mr-2 padding0">
                                <button pButton type="button" pTooltip="Download"
                                    (click)="downloadFile(lcaDetails.lcaApplication.sampleFileOne)"
                                    class="p-button-outlined"><i class="fa fa-download" aria-hidden="true"></i>Sample
                                    1</button>
                            </div>
                            <div *ngIf="lcaDetails.lcaApplication && lcaDetails.lcaApplication.sampleFileTwo"
                                class="mr-2 padding0">
                                <button pButton type="button" pTooltip="Download"
                                    (click)="downloadFile(lcaDetails.lcaApplication.sampleFileTwo)"
                                    class="p-button-outlined"><i class="fa fa-download" aria-hidden="true"></i>Sample
                                    2</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dashed-line pt-3 mb-4"></div>

                <div class="row mb-3 pl-3">
                    <h6 class="labelText"><b> Other Documents Upload</b></h6>
                </div>

                <div class="row">
                    <div class="col-12">
                        <app-file-upload style="width: 100%;" [configurations]="configurations"></app-file-upload>
                    </div>
                </div>

                <!-- Form Actions -->
                <div class="form-group mt-4 pl-2 text-right">
                    <button class="btn btn-outline" (click)="onCancel()">Cancel</button>
                    <button (click)="onSubmit()" class="btn btn-primary" [disabled]="!lcaForm.valid">
                        Save
                    </button>
                    
                </div>
            </form>

        </div>
    </div>
</div>